import Vue from 'vue'
import Router from 'vue-router'
import content from '@/view/content'
import dashboard from '@/view/dashboard'
import users from '@/view/users'
import customers from '@/view/customers'
import devices from '@/view/devices'
import logs from '@/view/logs'
import error from '@/view/error'
import leemmaLogin from '@/view/leemmaLogin'
import leemmaCustomer from '@/view/leemmaCustomer'
import wechatLogin from '@/view/wechatLogin'
// subSystem
import subSystem from '@/view/subSystem/subSystemList'
import subSystemNew from '@/view/subSystem/new'
import systemList from '@/view/subSystem/systemList'
import editCmds from '@/view/subSystem/editCmds'
import editEvent from '@/view/subSystem/editEvent'



import demo from '@/view/demo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/leemma',
      name: 'content',
      component: content,
      children:[
        {
          name:'员工管理',
          path:'users',
          component:users
        },
        {
          name:'客户管理',
          path:'customers',
          component:customers
        },
        {
          name:'设备管理',
          path:'devices',
          component:devices
        },
        {
          name:'日志管理',
          path:'logs',
          component:logs
        },
        {
          name:'状态总览',
          path:'/',
          component:dashboard
        },
        {
          name:'状态总览',
          path:'dashboard',
          component:dashboard
        },
        {
          name:'子系统',
          path:'subSystem',
          component:subSystem
        },
        {
          name:'添加子系统',
          path:'subSystemNew',
          component:subSystemNew
        },
        {
          name:'协议管理',
          path:'editCmds',
          component:editCmds
        },
        {
          name:'事件管理',
          path:'editEvent',
          component:editEvent
        },
        {
          name:'子系统s',
          path:'systemList',
          component:systemList
        },

      ]
    },
    {
      name:'利马员工登陆',
      path:'/leemmaLogin',
      component:leemmaLogin
    },
    {
      path:'/demo',
      name:'demo',
      component:demo
    },
    {
      path:'/leemmaCustomer',
      name:'leemmaCustomer',
      component:leemmaCustomer
    },
    {
      path:'/wechatLogin',
      name:'wechatLogin',
      component:wechatLogin
    },
    {
      path:'/error',
      name:'error',
      component:error
    },
    {
      path:'*',
      redirect:'/leemmaLogin'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js